var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UploadsListInnerTable',{attrs:{"item":{ record_id: _vm.$route.params.id, isas_error: _vm.item ? _vm.item.isas_error : null }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }